/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedLetterN = createReactComponent(
  "square-rounded-letter-n",
  "IconSquareRoundedLetterN",
  [
    ["path", { d: "M10 16v-8l4 8v-8", key: "svg-0" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconSquareRoundedLetterN as default };
//# sourceMappingURL=IconSquareRoundedLetterN.js.map
